export default __webpack_public_path__ + "static/media/14e40bc4a36c19d1.93b7669f942ccfa9781b83a87232d80e.svg";